// @format
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './PhoneWithPhoto.css';
import iphonexBg from './iphonexonly.png';
import iphonexBgMobile from './iphonexonly-mobile.png';
import MatchMedia from 'modules/components/MatchMedia';
import { isExist } from 'utils/ramdaUtils';

const PhoneWithPhoto = ({ className, contentUrl, children }) => (
  <MatchMedia mediaQueries="(min-width: 1149px)">
    {isMatched => (
      <div className={classnames('PhoneWithPhoto', className)}>
        <img src={isMatched ? iphonexBg : iphonexBgMobile} alt="phone" />
        <div className="PhoneWithPhoto-content">
          { isExist(contentUrl) &&
            <img
              className="PhoneWithPhoto-content-bg"
              src={contentUrl}
              alt="phone content"
            />
          }
          {children}
        </div>
      </div>
    )}
  </MatchMedia>
);

PhoneWithPhoto.propType = {
  contentUrl: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};

export default PhoneWithPhoto;



// WEBPACK FOOTER //
// ./src/modules/components/PhoneWithPhoto/PhoneWithPhoto.js